import axios from "axios";

class SignUpRequestApi {

    public requestCustomerUserEmail(customerUserId: string): Promise<void> {
        return axios.post(`/api/customeruser/${customerUserId}/requestSignUp/`);
    }

    public requestEmployeeEmail(customerUserId: string, employeeId: string): Promise<void> {
        return axios.post(`/api/customer/${customerUserId}/employeerecord/${employeeId}/requestSignUp`);
    }

    public resetCustomerUserEmail(customerUserId: string): Promise<void> {
        return axios.post(`/api/customeruser/${customerUserId}/resetemail`);
    }

    public resetEmployeeUserEmail(customerId: string, employeeId: string): Promise<void> {
        return axios.post(`/api/customer/${customerId}/employeerecord/${employeeId}/resetemail`);
    }
}

export default new SignUpRequestApi();
